import type { GraphQLError } from 'graphql';

export const findAuthenticationError = (
  errors: readonly GraphQLError[] | undefined,
): GraphQLError | undefined => {
  if (errors) {
    return errors.find(
      (error) =>
        error.extensions && error.extensions.code === 'UNAUTHENTICATED',
    );
  }
  return;
};
